import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const HelpContext = createContext(null);

export function HelpProvider({ children }) {
  const [helpKey, _setHelpKey] = useState(null);

  const setHelpKey = useCallback((key) => {
    _setHelpKey(key);
  }, []);

  return (
    <HelpContext.Provider value={{ helpKey, setHelpKey }}>
      {children}
    </HelpContext.Provider>
  );
}

export function useHelp() {
  const ctx = useContext(HelpContext);
  if (!ctx) throw new Error("HelpProvider missing");
  return ctx;
}

// Convenience hook: register a helpKey while the component is mounted and
// restore the previous key on unmount (so navigating away resets the context).
export function useSetHelpKey(key) {
  const { setHelpKey } = useHelp();
  useEffect(() => {
    setHelpKey(key);
    return () => setHelpKey(null);
  }, [key, setHelpKey]);
}
